import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=4984d27a"
import script from "./sub-menu.vue?vue&type=script&lang=js"
export * from "./sub-menu.vue?vue&type=script&lang=js"
import style0 from "./sub-menu.vue?vue&type=style&index=0&id=4984d27a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports